<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.805"
    height="25.805"
    viewBox="0 0 25.805 25.805"
  >
    <g
      id="Icon_feather-search"
      data-name="Icon feather-search"
      transform="translate(-3.5 -3.5)"
    >
      <path
        id="Path_5"
        data-name="Path 5"
        d="M25.292,14.9A10.4,10.4,0,1,1,14.9,4.5a10.4,10.4,0,0,1,10.4,10.4Z"
        transform="translate(0 0)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_6"
        data-name="Path 6"
        d="M30.628,30.628l-5.653-5.653"
        transform="translate(-2.737 -2.737)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon'
};
</script>

<style></style>
